import { Component, Input, Output, EventEmitter } from '@angular/core';

// INTERFACES
import { trackById, trackByValue } from '../../../shared/util/track-by.util';
import { IPickingItem } from '../../interfaces/order-sales.interface';

@Component({
  selector: 'lum-order-posted-items-table',
  templateUrl: './order-posted-items-table.component.html',
  styleUrls: ['./order-posted-items-table.component.scss'],
})
export class OrderPostedItemsTableComponent {
  @Input()
  pickingItems :IPickingItem[];

  @Output()
  createAdjustmentEntryEvent = new EventEmitter<number>();

  trackByValue = trackByValue;
  trackById = trackById;

  createAdjustmentEntry(rfqId :number) :void {
    this.createAdjustmentEntryEvent.emit(rfqId);
  }
}
